import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap";
import VOtpInput from "vue3-otp-input";
import { AVPlugin } from "vue-audio-visual";
import i18n from "@/I18n.js";
import { authPermission } from "@/helpers/authServices/auth.permission";
import "@/assets/sass/style.css";
import "@/assets/sass/media.css";
import CKEditor from "@ckeditor/ckeditor5-vue";
import VueApexCharts from "vue3-apexcharts";
import VLazyImage from "v-lazy-image";
import ModalPlugin from "@/helpers/Navigation.js";

// import { onOpenMqtt } from "./helpers/indexMqtt";
// const connectionStr = onOpenMqtt();

import "./plugins";

const app = createApp(App);
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Title,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title
);

import VueFeather from "vue-feather";

import VueGoogleMaps from "@fawmi/vue-google-maps";
app.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCdNPEZUlqr2gjnXXotK-XlAkNzhg0DHpA",
  },
});

app.directive("permission", authPermission);

// if (connectionStr) {
//   app.config.globalProperties.$mqttConnection = connectionStr;
// }
app.component(VueFeather.name, VueFeather);
app.component("v-otp-input", VOtpInput);
app.component("VLazy", VLazyImage);
app.use(ModalPlugin);
app.use(CKEditor);
app.use(i18n);
app.use(Antd);
app.use(store);
app.use(router);
app.use(AVPlugin);
app.use(VueApexCharts);
app.mount("#app");
